import styled from 'styled-components';
import Form from 'react-bootstrap/Form';

export const StyledDescription = styled(Form.Label)`
  font-weight: 400 !important;
  color: #AAAEBB;
  padding-left: 0;
  padding-top: 0;
`;
